import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=2a01aa48"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"
import style0 from "./Related.vue?vue&type=style&index=0&id=2a01aa48&prod&lang=scss"
import style1 from "./Related.vue?vue&type=style&index=1&id=2a01aa48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-company_Yo6Q/components/common/commonImg.vue').default})
